import { useState, useEffect } from 'react';
import '../../styles/UserForm.css';

const UserForm = ({ 
  onSubmit, 
  onCancel, 
  tenants = [], 
  currentTenant,
  loading = false,
  isSuperAdmin = false,
  currentUser
}) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    tenantId: currentTenant?.id || '',
    role: 'global_admin', // Default role
    isActive: true
  });

  useEffect(() => {
    if (currentTenant) {
      setFormData(prev => ({ ...prev, tenantId: currentTenant.id }));
    }
  }, [currentTenant]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleRoleChange = (e) => {
    const role = e.target.value;
    setFormData(prev => ({
      ...prev,
      role,
      isAdmin: role === 'global_admin' || role === 'location_admin'
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...formData,
      isAdmin: formData.role === 'global_admin' || formData.role === 'location_admin',
      isGlobalAdmin: formData.role === 'global_admin',
      isSuperAdmin: false // Only set this if explicitly needed
    });
  };

  return (
    <form className="user-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label>First Name*</label>
        <input
          type="text"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          required
          disabled={loading}
        />
      </div>

      <div className="form-group">
        <label>Last Name*</label>
        <input
          type="text"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          required
          disabled={loading}
        />
      </div>

      <div className="form-group">
        <label>Email*</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          disabled={loading}
        />
      </div>

      <div className="form-group">
        <label>Password* (min 6 characters)</label>
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          minLength="6"
          disabled={loading}
        />
      </div>

      <div className="form-group">
        <label>Role*</label>
        <select
          name="role"
          value={formData.role}
          onChange={handleRoleChange}
          required
          disabled={loading}
        >
          {isSuperAdmin && <option value="global_admin">Global Admin</option>}
        </select>
      </div>

      {isSuperAdmin && (
        <div className="form-group">
          <label>Tenant*</label>
          <select
            name="tenantId"
            value={formData.tenantId}
            onChange={handleChange}
            required
            disabled={!!currentTenant || loading}
          >
            <option value="">Select Tenant</option>
            {tenants.map(tenant => (
              <option key={tenant.id} value={tenant.id}>
                {tenant.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="form-actions">
        <button type="submit" className="submit-bt" disabled={loading}>
          {loading ? 'Creating...' : 'Create User'}
        </button>
        <button 
          type="button" 
          onClick={onCancel} 
          className="cancel-btn"
          disabled={loading}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default UserForm;